'use client';

import { useEffect } from 'react';

import { Button } from '@/components/ui/button';
import { reportClientError } from '@/lib/errors/report-client-error';
import { reloadOnceForChunkLoad } from '@/lib/errors/chunk-load-recovery';

/**
 * Route-level error UI. Must NOT render <html>/<body> — those belong only in
 * root layout (and global-error.tsx). Nesting them causes soft-nav document errors.
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (reloadOnceForChunkLoad(error)) {
      return;
    }
    reportClientError({
      message: error.message,
      digest: error.digest,
    });
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="max-w-md space-y-4 text-center">
        <h1 className="text-2xl font-semibold">Something went wrong</h1>
        <p className="text-sm text-muted-foreground">
          An unexpected error occurred. Please try again.
        </p>
        <Button onClick={() => reset()}>Try again</Button>
      </div>
    </div>
  );
}
